var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { faAngleDown as fasAngleDown } from '@fortawesome/free-solid-svg-icons/faAngleDown';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faAnglesDown as fasAnglesDown } from '@fortawesome/free-solid-svg-icons/faAnglesDown';
import { faAnglesLeft as fasAnglesLeft } from '@fortawesome/free-solid-svg-icons/faAnglesLeft';
import { faAnglesRight as fasAnglesRight } from '@fortawesome/free-solid-svg-icons/faAnglesRight';
import { faAnglesUp as fasAnglesUp } from '@fortawesome/free-solid-svg-icons/faAnglesUp';
import { faAngleUp as fasAngleUp } from '@fortawesome/free-solid-svg-icons/faAngleUp';
import { faArrowDown as fasArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faArrowDownAZ as fasArrowDownAZ } from '@fortawesome/free-solid-svg-icons/faArrowDownAZ';
import { faArrowDownShortWide as fasArrowDownShortWide } from '@fortawesome/free-solid-svg-icons/faArrowDownShortWide';
import { faArrowDownWideShort as fasArrowDownWideShort } from '@fortawesome/free-solid-svg-icons/faArrowDownWideShort';
import { faArrowDownZA as fasArrowDownZA } from '@fortawesome/free-solid-svg-icons/faArrowDownZA';
import { faArrowLeft as fasArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight as fasArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowRightArrowLeft as fasArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowRightArrowLeft';
import { faArrowRightFromBracket as fasArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons/faArrowRightFromBracket';
import { faArrowRightToBracket as fasArrowRightToBracket } from '@fortawesome/free-solid-svg-icons/faArrowRightToBracket';
import { faArrowRotateLeft as fasArrowRotateLeft } from '@fortawesome/free-solid-svg-icons/faArrowRotateLeft';
import { faArrowRotateRight as fasArrowRotateRight } from '@fortawesome/free-solid-svg-icons/faArrowRotateRight';
import { faArrowsRotate as fasArrowsRotate } from '@fortawesome/free-solid-svg-icons/faArrowsRotate';
import { faArrowsSpin as fasArrowsSpin } from '@fortawesome/free-solid-svg-icons/faArrowsSpin';
import { faArrowTurnDown as fasArrowTurnDown } from '@fortawesome/free-solid-svg-icons/faArrowTurnDown';
import { faArrowTurnUp as fasArrowTurnUp } from '@fortawesome/free-solid-svg-icons/faArrowTurnUp';
import { faArrowUp as fasArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faArrowUpAZ as fasArrowUpAZ } from '@fortawesome/free-solid-svg-icons/faArrowUpAZ';
import { faArrowUpFromBracket as fasArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons/faArrowUpFromBracket';
import { faArrowDownToLine as fasArrowDownToLine } from '@fortawesome/pro-solid-svg-icons/faArrowDownToLine';
import { faArrowUpShortWide as fasArrowUpShortWide } from '@fortawesome/free-solid-svg-icons/faArrowUpShortWide';
import { faArrowUpWideShort as fasArrowUpWideShort } from '@fortawesome/free-solid-svg-icons/faArrowUpWideShort';
import { faArrowUpZA as fasArrowUpZA } from '@fortawesome/free-solid-svg-icons/faArrowUpZA';
import { faBan as fasBan } from '@fortawesome/free-solid-svg-icons/faBan';
import { faBars as fasBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faCaretDown as fasCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/free-solid-svg-icons/faCaretLeft';
import { faCaretRight as fasCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCaretUp as fasCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCheck as fasCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCircleArrowDown as fasCircleArrowDown } from '@fortawesome/free-solid-svg-icons/faCircleArrowDown';
import { faCircleArrowLeft as fasCircleArrowLeft } from '@fortawesome/free-solid-svg-icons/faCircleArrowLeft';
import { faCircleArrowRight as fasCircleArrowRight } from '@fortawesome/free-solid-svg-icons/faCircleArrowRight';
import { faCircleArrowUp as fasCircleArrowUp } from '@fortawesome/free-solid-svg-icons/faCircleArrowUp';
import { faCircleChevronDown as fasCircleChevronDown } from '@fortawesome/free-solid-svg-icons/faCircleChevronDown';
import { faCircleChevronLeft as fasCircleChevronLeft } from '@fortawesome/free-solid-svg-icons/faCircleChevronLeft';
import { faCircleChevronRight as fasCircleChevronRight } from '@fortawesome/free-solid-svg-icons/faCircleChevronRight';
import { faCircleChevronUp as fasCircleChevronUp } from '@fortawesome/free-solid-svg-icons/faCircleChevronUp';
import { faCircleExclamation as fasCircleExclamation } from '@fortawesome/free-solid-svg-icons/faCircleExclamation';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/free-solid-svg-icons/faCircleNotch';
import { faCircleUser as fasCircleUser } from '@fortawesome/free-solid-svg-icons/faCircleUser';
import { faClockRotateLeft as fasClockRotateLeft } from '@fortawesome/free-solid-svg-icons/faClockRotateLeft';
import { faExternalLink as fasExternalLink } from '@fortawesome/free-solid-svg-icons/faExternalLink';
import { faEye as fasEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faEyeSlash as fasEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faFaceFrown as fasFaceFrown } from '@fortawesome/free-solid-svg-icons/faFaceFrown';
import { faFaceLaugh as fasFaceLaugh } from '@fortawesome/free-solid-svg-icons/faFaceLaugh';
import { faFaceMeh as fasFaceMeh } from '@fortawesome/free-solid-svg-icons/faFaceMeh';
import { faFaceSmile as fasFaceSmile } from '@fortawesome/free-solid-svg-icons/faFaceSmile';
import { faFilter as fasFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFilterCircleXmark as fasFilterCircleXmark } from '@fortawesome/free-solid-svg-icons/faFilterCircleXmark';
import { faFolder as fasFolder } from '@fortawesome/free-solid-svg-icons/faFolder';
import { faFolderOpen as fasFolderOpen } from '@fortawesome/free-solid-svg-icons/faFolderOpen';
import { faGear as fasGear } from '@fortawesome/free-solid-svg-icons/faGear';
import { faGlobe as fasGlobe } from '@fortawesome/free-solid-svg-icons/faGlobe';
import { faInfoCircle as fasInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faLink as fasLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faMagnifyingGlassMinus as fasMagnifyingGlassMinus } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassMinus';
import { faMagnifyingGlassPlus as fasMagnifyingGlassPlus } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassPlus';
import { faPaperclip as fasPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip';
import { faPen as fasPen } from '@fortawesome/free-solid-svg-icons/faPen';
import { faPenClip as fasPenClip } from '@fortawesome/free-solid-svg-icons/faPenClip';
import { faPenNib as fasPenNib } from '@fortawesome/free-solid-svg-icons/faPenNib';
import { faPenRuler as fasPenRuler } from '@fortawesome/free-solid-svg-icons/faPenRuler';
import { faPenToSquare as fasPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare';
import { faRepeat as fasRepeat } from '@fortawesome/free-solid-svg-icons/faRepeat';
import { faReply as fasReply } from '@fortawesome/free-solid-svg-icons/faReply';
import { faReplyAll as fasReplyAll } from '@fortawesome/free-solid-svg-icons/faReplyAll';
import { faRightFromBracket as fasRightFromBracket } from '@fortawesome/free-solid-svg-icons/faRightFromBracket';
import { faRightLeft as fasRightLeft } from '@fortawesome/free-solid-svg-icons/faRightLeft';
import { faRightToBracket as fasRightToBracket } from '@fortawesome/free-solid-svg-icons/faRightToBracket';
import { faScissors as fasScissors } from '@fortawesome/free-solid-svg-icons/faScissors';
import { faScrewdriverWrench as fasScrewdriverWrench } from '@fortawesome/free-solid-svg-icons/faScrewdriverWrench';
import { faSearch as fasSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faShare as fasShare } from '@fortawesome/free-solid-svg-icons/faShare';
import { faShareFromSquare as fasShareFromSquare } from '@fortawesome/free-solid-svg-icons/faShareFromSquare';
import { faShareNodes as fasShareNodes } from '@fortawesome/free-solid-svg-icons/faShareNodes';
import { faShuffle as fasShuffle } from '@fortawesome/free-solid-svg-icons/faShuffle';
import { faSliders as fasSliders } from '@fortawesome/free-solid-svg-icons/faSliders';
import { faSort as fasSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faSortDown as fasSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
import { faSortUp as fasSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
import { faSquareCaretDown as fasSquareCaretDown } from '@fortawesome/free-solid-svg-icons/faSquareCaretDown';
import { faSquareCaretLeft as fasSquareCaretLeft } from '@fortawesome/free-solid-svg-icons/faSquareCaretLeft';
import { faSquareCaretRight as fasSquareCaretRight } from '@fortawesome/free-solid-svg-icons/faSquareCaretRight';
import { faSquareCaretUp as fasSquareCaretUp } from '@fortawesome/free-solid-svg-icons/faSquareCaretUp';
import { faStar as fasStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faStarHalf as fasStarHalf } from '@fortawesome/free-solid-svg-icons/faStarHalf';
import { faStarHalfStroke as fasStarHalfStroke } from '@fortawesome/free-solid-svg-icons/faStarHalfStroke';
import { faThumbsDown as fasThumbsDown } from '@fortawesome/free-solid-svg-icons/faThumbsDown';
import { faThumbsUp as fasThumbsUp } from '@fortawesome/free-solid-svg-icons/faThumbsUp';
import { faTrash as fasTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import { faTrashCan as fasTrashCan } from '@fortawesome/free-solid-svg-icons/faTrashCan';
import { faTriangleExclamation as fasTriangleExclamation } from '@fortawesome/free-solid-svg-icons/faTriangleExclamation';
import { faXmark as fasXmark } from '@fortawesome/free-solid-svg-icons/faXmark';
import { faXmarkCircle as fasXmarkCircle } from '@fortawesome/free-solid-svg-icons/faXmarkCircle';
import { faArrowPointer as fasArrowPointer } from '@fortawesome/free-solid-svg-icons/faArrowPointer';
import { faArrowUpRightFromSquare as fasArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';
import { faBell as fasBell } from '@fortawesome/free-solid-svg-icons/faBell';
import { faBellSlash as fasBellSlash } from '@fortawesome/free-solid-svg-icons/faBellSlash';
import { faBookmark as fasBookmark } from '@fortawesome/free-solid-svg-icons/faBookmark';
import { faCookieBite as fasCookieBite } from '@fortawesome/free-solid-svg-icons/faCookieBite';
import { faHeart as fasHeart } from '@fortawesome/free-solid-svg-icons/faHeart';
import { faHouse as fasHouse } from '@fortawesome/free-solid-svg-icons/faHouse';
import { faHouseChimney as fasHouseChimney } from '@fortawesome/free-solid-svg-icons/faHouseChimney';
import { faImage as fasImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faLightbulb as fasLightBulb } from '@fortawesome/free-solid-svg-icons/faLightbulb';
import { faPhone as fasPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faThumbtack as fasThumbtack } from '@fortawesome/free-solid-svg-icons/faThumbtack';
import { faUniversalAccess as fasUniversalAccess } from '@fortawesome/free-solid-svg-icons/faUniversalAccess';
import { faWrench as fasWrench } from '@fortawesome/free-solid-svg-icons/faWrench';
import { faFileExcel as fasFileExcel } from '@fortawesome/pro-solid-svg-icons/faFileExcel';
import { faFilePdf as fasFilePdf } from '@fortawesome/pro-solid-svg-icons/faFilePdf';
import { faFilePowerpoint as fasFilePowerPoint } from '@fortawesome/pro-solid-svg-icons/faFilePowerpoint';
import { faFileWord as fasFileWord } from '@fortawesome/pro-solid-svg-icons/faFileWord';
import { faCalendarDays as fasCalendarDays } from '@fortawesome/free-solid-svg-icons/faCalendarDays';
import { faFile as fasFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faFileLines as fasFileLines } from '@fortawesome/free-solid-svg-icons/faFileLines';
import { faLocationCrosshairs as fasLocationCrosshairs } from '@fortawesome/free-solid-svg-icons/faLocationCrosshairs';
import { faLocationDot as fasLocationDot } from '@fortawesome/free-solid-svg-icons/faLocationDot';
import { faMapLocationDot as fasMapLocationDot } from '@fortawesome/free-solid-svg-icons/faMapLocationDot';
import { faTag as fasTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faBolt as fasBolt } from '@fortawesome/free-solid-svg-icons/faBolt';
import { faBookBookmark as fasBookBookmark } from '@fortawesome/free-solid-svg-icons/faBookBookmark';
import { faBriefcase as fasBriefcase } from '@fortawesome/free-solid-svg-icons/faBriefcase';
import { faClock as fasClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCreditCard as fasCreditCard } from '@fortawesome/free-solid-svg-icons/faCreditCard';
import { faEarthAmerica as fasEarthAmerica } from '@fortawesome/free-solid-svg-icons/faEarthAmerica';
import { faFlag as fasFlag } from '@fortawesome/free-solid-svg-icons/faFlag';
import { faLock as fasLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faStopwatch as fasStopwatch } from '@fortawesome/free-solid-svg-icons/faStopwatch';
import { faUnlock as fasUnlock } from '@fortawesome/free-solid-svg-icons/faUnlock';
import { faCamera as fasCamera } from '@fortawesome/free-solid-svg-icons/faCamera';
import { faComment as fasComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faComments as fasComments } from '@fortawesome/free-solid-svg-icons/faComments';
import { faEnvelope as fasEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faHourglass as fasHourglass } from '@fortawesome/free-solid-svg-icons/faHourglass';
import { faHourglassHalf as fasHourglassHalf } from '@fortawesome/free-solid-svg-icons/faHourglassHalf';
import { faLocationArrow as fasLocationArrow } from '@fortawesome/free-solid-svg-icons/faLocationArrow';
import { faMaximize as fasMaximize } from '@fortawesome/free-solid-svg-icons/faMaximize';
import { faMinimize as fasMinimize } from '@fortawesome/free-solid-svg-icons/faMinimize';
import { faQuoteLeft as fasQuoteLeft } from '@fortawesome/free-solid-svg-icons/faQuoteLeft';
import { faQuoteRight as fasQuoteRight } from '@fortawesome/free-solid-svg-icons/faQuoteRight';
import { faVideo as fasVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faListUl as fasListUl } from '@fortawesome/free-solid-svg-icons/faListUl';
import { faSpinner as fasSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faUser as fasUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUserGroup as fasUserGroup } from '@fortawesome/free-solid-svg-icons/faUserGroup';
import { faUsers as fasUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faEllipsis as fasEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis';
import { faMinus as fasMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPlus as fasPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faEllipsisVertical as fasEllipsisVertical } from '@fortawesome/free-solid-svg-icons/faEllipsisVertical';
import { faCircleXmark as fasCircleXmark } from '@fortawesome/free-solid-svg-icons/faCircleXmark';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faFacebookF as fabFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faLinkedinIn as fabLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faMagnifyingGlass as fasMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { faLoader as fadLoader } from '@fortawesome/pro-duotone-svg-icons/faLoader';
import { faWhatsapp as fabWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faCircle as fasCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faCircleCheck as fasCircleCheck } from '@fortawesome/free-solid-svg-icons/faCircleCheck';
import { faCode as fasCode } from '@fortawesome/free-solid-svg-icons/faCode';
import { faCopy as fasCopy } from '@fortawesome/free-solid-svg-icons/faCopy';
import { faFax as fasFax } from '@fortawesome/free-solid-svg-icons/faFax';
import { faMicrophone as fasMicrophone } from '@fortawesome/free-solid-svg-icons/faMicrophone';
import { faPause as fasPause } from '@fortawesome/free-solid-svg-icons/faPause';
import { faPlay as fasPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faRotateLeft as fasRotateLeft } from '@fortawesome/free-solid-svg-icons/faRotateLeft';
import { faRotateRight as fasRotateRight } from '@fortawesome/free-solid-svg-icons/faRotateRight';
import { faBrowser as fasBrowser } from '@fortawesome/pro-solid-svg-icons/faBrowser';
import { faCircleQuarterStroke as fasCircleQuarterStroke } from '@fortawesome/pro-solid-svg-icons/faCircleQuarterStroke';
import { faCircleThreeQuartersStroke as fasCircleThreeQuartersStroke } from '@fortawesome/pro-solid-svg-icons/faCircleThreeQuartersStroke';
import { faFileMagnifyingGlass as fasFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faFileMagnifyingGlass';
import { faFileZip as fasFileZip } from '@fortawesome/pro-solid-svg-icons/faFileZip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './styles.css';
export var iconMap = {
    'fab-facebook': fabFacebook,
    'fab-facebook-f': fabFacebookF,
    'fab-instagram': fabInstagram,
    'fab-linkedin': fabLinkedin,
    'fab-linkedin-in': fabLinkedinIn,
    'fab-twitter': fabTwitter,
    'fab-x-twitter': fabXTwitter,
    'fab-youtube': fabYoutube,
    'fab-whatsapp': fabWhatsapp,
    'fas-angle-down': fasAngleDown,
    'fas-angle-left': fasAngleLeft,
    'fas-angle-right': fasAngleRight,
    'fas-angle-up': fasAngleUp,
    'fas-angles-down': fasAnglesDown,
    'fas-angles-left': fasAnglesLeft,
    'fas-angles-right': fasAnglesRight,
    'fas-angles-up': fasAnglesUp,
    'fas-arrow-down-az': fasArrowDownAZ,
    'fas-arrow-down-to-line': fasArrowDownToLine,
    'fas-arrow-down-short-wide': fasArrowDownShortWide,
    'fas-arrow-down-wide-short': fasArrowDownWideShort,
    'fas-arrow-down-za': fasArrowDownZA,
    'fas-arrow-down': fasArrowDown,
    'fas-arrow-left': fasArrowLeft,
    'fas-arrow-pointer': fasArrowPointer,
    'fas-arrow-right-arrow-left': fasArrowRightArrowLeft,
    'fas-arrow-right-from-bracket': fasArrowRightFromBracket,
    'fas-arrow-right-to-bracket': fasArrowRightToBracket,
    'fas-arrow-right': fasArrowRight,
    'fas-arrow-rotate-left': fasArrowRotateLeft,
    'fas-arrow-rotate-right': fasArrowRotateRight,
    'fas-arrow-turn-down': fasArrowTurnDown,
    'fas-arrow-turn-up': fasArrowTurnUp,
    'fas-arrow-up-az': fasArrowUpAZ,
    'fas-arrow-up-from-bracket': fasArrowUpFromBracket,
    'fas-arrow-up-right-from-square': fasArrowUpRightFromSquare,
    'fas-arrow-up-short-wide': fasArrowUpShortWide,
    'fas-arrow-up-wide-short': fasArrowUpWideShort,
    'fas-arrow-up-za': fasArrowUpZA,
    'fas-arrow-up': fasArrowUp,
    'fas-arrows-rotate': fasArrowsRotate,
    'fas-arrows-spin': fasArrowsSpin,
    'fas-ban': fasBan,
    'fas-bars': fasBars,
    'fas-bell-slash': fasBellSlash,
    'fas-bell': fasBell,
    'fas-bolt': fasBolt,
    'fas-book-bookmark': fasBookBookmark,
    'fas-bookmark': fasBookmark,
    'fas-briefcase': fasBriefcase,
    'fas-browser': fasBrowser,
    'fas-calendar-days': fasCalendarDays,
    'fas-camera': fasCamera,
    'fas-caret-down': fasCaretDown,
    'fas-caret-left': fasCaretLeft,
    'fas-caret-right': fasCaretRight,
    'fas-caret-up': fasCaretUp,
    'fas-check': fasCheck,
    'fas-circle': fasCircle,
    'fas-circle-arrow-down': fasCircleArrowDown,
    'fas-circle-arrow-left': fasCircleArrowLeft,
    'fas-circle-arrow-right': fasCircleArrowRight,
    'fas-circle-arrow-up': fasCircleArrowUp,
    'fas-circle-chevron-down': fasCircleChevronDown,
    'fas-circle-chevron-left': fasCircleChevronLeft,
    'fas-circle-chevron-right': fasCircleChevronRight,
    'fas-circle-chevron-up': fasCircleChevronUp,
    'fas-circle-check': fasCircleCheck,
    'fas-circle-exclamation': fasCircleExclamation,
    'fas-circle-notch': fasCircleNotch,
    'fas-circle-quarter-stroke': fasCircleQuarterStroke,
    'fas-circle-three-quarters-stroke': fasCircleThreeQuartersStroke,
    'fas-circle-user': fasCircleUser,
    'fas-circle-xmark': fasCircleXmark,
    'fas-clock-rotate-left': fasClockRotateLeft,
    'fas-clock': fasClock,
    'fas-code': fasCode,
    'fas-comment': fasComment,
    'fas-comments': fasComments,
    'fas-cookie-bite': fasCookieBite,
    'fas-copy': fasCopy,
    'fas-credit-card': fasCreditCard,
    'fas-earth-america': fasEarthAmerica,
    'fas-ellipsis-vertical': fasEllipsisVertical,
    'fas-ellipsis': fasEllipsis,
    'fas-envelope': fasEnvelope,
    'fas-external-link': fasExternalLink,
    'fas-eye-slash': fasEyeSlash,
    'fas-eye': fasEye,
    'fas-face-frown': fasFaceFrown,
    'fas-face-laugh': fasFaceLaugh,
    'fas-face-meh': fasFaceMeh,
    'fas-face-smile': fasFaceSmile,
    'fas-fax': fasFax,
    'fas-file-magnifying-glass': fasFileMagnifyingGlass,
    'fas-file-lines': fasFileLines,
    'fas-file': fasFile,
    'fas-word': fasFileWord,
    'fas-powerpoint': fasFilePowerPoint,
    'fas-excel': fasFileExcel,
    'fas-pdf': fasFilePdf,
    'fas-other': fasFile,
    'fas-filter-circle-xmark': fasFilterCircleXmark,
    'fas-filter': fasFilter,
    'fas-file-zip': fasFileZip,
    'fas-flag': fasFlag,
    'fas-folder-open': fasFolderOpen,
    'fas-folder': fasFolder,
    'fas-gear': fasGear,
    'fas-magnifying': fasMagnifyingGlass,
    'fas-globe': fasGlobe,
    'fas-heart': fasHeart,
    'fas-hourglass-half': fasHourglassHalf,
    'fas-hourglass': fasHourglass,
    'fas-house-chimney': fasHouseChimney,
    'fas-house': fasHouse,
    'fas-image': fasImage,
    'fas-info-circle': fasInfoCircle,
    'fas-light-bulb': fasLightBulb,
    'fas-link': fasLink,
    'fas-list-ul': fasListUl,
    'fas-location-arrow': fasLocationArrow,
    'fas-location-crosshairs': fasLocationCrosshairs,
    'fas-location-dot': fasLocationDot,
    'fas-lock': fasLock,
    'fas-magnifying-glass-minus': fasMagnifyingGlassMinus,
    'fas-magnifying-glass-plus': fasMagnifyingGlassPlus,
    'fas-map-location-dot': fasMapLocationDot,
    'fas-maximize': fasMaximize,
    'fas-minimize': fasMinimize,
    'fas-minus': fasMinus,
    'fas-paperclip': fasPaperclip,
    'fas-pause': fasPause,
    'fas-pen-clip': fasPenClip,
    'fas-pen-nib': fasPenNib,
    'fas-pen-ruler': fasPenRuler,
    'fas-pen-to-square': fasPenToSquare,
    'fas-pen': fasPen,
    'fas-phone': fasPhone,
    'fas-plus': fasPlus,
    'fas-play': fasPlay,
    'fas-quote-left': fasQuoteLeft,
    'fas-quote-right': fasQuoteRight,
    'fas-repeat': fasRepeat,
    'fas-reply-all': fasReplyAll,
    'fas-reply': fasReply,
    'fas-right-from-bracket': fasRightFromBracket,
    'fas-right-left': fasRightLeft,
    'fas-right-to-bracket': fasRightToBracket,
    'fas-rotate-right': fasRotateRight,
    'fas-rotate-left': fasRotateLeft,
    'fas-scissors': fasScissors,
    'fas-screwdriver-wrench': fasScrewdriverWrench,
    'fas-search': fasSearch,
    'fas-share-from-square': fasShareFromSquare,
    'fas-share-nodes': fasShareNodes,
    'fas-share': fasShare,
    'fas-shuffle': fasShuffle,
    'fas-sliders': fasSliders,
    'fas-sort-down': fasSortDown,
    'fas-sort-up': fasSortUp,
    'fas-sort': fasSort,
    'fas-spinner': fasSpinner,
    'fas-square-caret-down': fasSquareCaretDown,
    'fas-square-caret-left': fasSquareCaretLeft,
    'fas-square-caret-right': fasSquareCaretRight,
    'fas-square-caret-up': fasSquareCaretUp,
    'fas-star-half-stroke': fasStarHalfStroke,
    'fas-star-half': fasStarHalf,
    'fas-star': fasStar,
    'fas-stopwatch': fasStopwatch,
    'fas-tag': fasTag,
    'fas-thumbs-down': fasThumbsDown,
    'fas-thumbs-up': fasThumbsUp,
    'fas-thumbtack': fasThumbtack,
    'fas-trash-can': fasTrashCan,
    'fas-trash': fasTrash,
    'fas-triangle-exclamation': fasTriangleExclamation,
    'fas-universal-access': fasUniversalAccess,
    'fas-unlock': fasUnlock,
    'fas-user-group': fasUserGroup,
    'fas-user': fasUser,
    'fas-users': fasUsers,
    'fas-video': fasVideo,
    'fas-wrench': fasWrench,
    'fas-xmark-circle': fasXmarkCircle,
    'fas-xmark': fasXmark,
    'fad-loader': fadLoader,
    'fa-microphone': fasMicrophone,
};
var IconFont = function (props) {
    var icon = iconMap[props.type];
    var size = props.size || '16';
    var color = props.color ? { color: props.color } : {};
    var style = props.style ? { style: props.style } : {};
    var classes = classNames(props.className, 'rotaryui-icon', "size-".concat(size));
    var pulse = props.pulse || false;
    return (_jsx(FontAwesomeIcon, __assign({ icon: icon, className: classes }, color, style, { pulse: pulse })));
};
export default IconFont;
//# sourceMappingURL=icon-font.js.map